import type { FrameType } from "@/api/spaces";
import { newDocContent } from "./doc-content";
import { plainTextDocContent } from "./plain-text-markdown";

/**
 * Where a new Doc's body comes from:
 * - `markdown`: the note tools or a markdown file; read as markdown
 * - `plain`: a plain-text file; kept exactly
 */
export type NewTextSource = "markdown" | "plain";

/** Type and content of a Doc a person creates from the note tools or a text file. */
export function newTextFrameFields(
  text = "",
  source: NewTextSource = "markdown",
): {
  frame_type: FrameType;
  content: Record<string, unknown>;
} {
  const content =
    source === "plain" ? plainTextDocContent(text) : newDocContent(text);
  return { frame_type: "doc", content: { ...content } };
}
